module.exports = __webpack_public_path__ + "img/piazza 2.1e72d347.jpeg";